module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.00861in",
      "height": "3.47917in",
      "filter": "grayscale(100%)"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Carmel Liddell’s latest novel, "), _c('em', [_vm._v("Abbie Brown: On the Cusp")]), _vm._v(", explores the life and times of 34-year-old Abbie (single – 73kgs), who is looking for love.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Having been there, and done that, Carmel tells the tale with a great deal of humour, affection and understanding.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("The Australian author’s other books include:")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("Short Stories A-Z")]), _vm._v(" – 2023")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("Love and Kisses Pauline xxx")]), _vm._v(" – 2022")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("Reggie Carstairs: Behind Closed Eyes")]), _vm._v(" – 2021")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("The Beachmaster (Childrens’ Picture Book)")]), _vm._v(" - 2026")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0